import Utils from "../utils/Utils";
const BulkUpdateController = {
  export: ({ Authorization, request }) => {
    return Utils.controller(
      "api/product/v1/bulkUpdate/export",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
      false,
      "blob",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, */*",
    );
  },
  import: ({ Authorization, companyId, file, validateOnly }) => {
    const formData = new FormData();
    formData.append("file", file);

    return Utils.controller(
      "api/product/v1/bulkUpdate/import",
      formData,
      "POST",
      `companyId=${companyId}&validateOnly=${validateOnly}`,
      true,
      Authorization,
      false,
      false,
      "blob",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, */*",
    );
  },
};
export default BulkUpdateController;
